import Ethereum from '../assets/ethereum (1).svg';
import EthereumCoins from '../assets/coins.svg';

export function EthereumIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={Ethereum} alt='Ethereum' />;
}

export function EthereumCoinsIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={EthereumCoins} alt='Ethereum Coins' />;
}
